import React, { useState, useEffect } from 'react';

import { useQuery } from 'react-query';

import classes from './styles.module.scss';
import UserService from '../../../../services/UserService';
import getUserPhotoUrl from '../../../../helpers/getUserPhotoUrl';
import prolfileIcon from '../../../../assets/images/profile.svg';
import validateEmail from '../../../../helpers/validateEmail';

let timeout;

export default function UserSearchSuggestion({
  value,
  setValue,
  setIsUserSearchSuggestionVisible,
  canCreateUser,
  onCreateUserRequest,
  requireSuggestionSelection,
  onSuggestionSelected,
}) {
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');

  const { data, isLoading } = useQuery(['suggestedUsers', debouncedSearchQuery], () =>
    UserService.suggestUsers(debouncedSearchQuery)
  );

  useEffect(() => {
    if (!value) {
      return;
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const lastEmail = value.split(';').pop().trim();
      setDebouncedSearchQuery(lastEmail);
    }, 500);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timeout);
  }, [value]);

  if (!value) {
    return null;
  }

  const lastEmail = value.split(';').pop().trim();

  // Show "no users found" message when requireSuggestionSelection is enabled and no matches
  // This takes priority over canCreateUser when strict selection is required
  if (requireSuggestionSelection && debouncedSearchQuery && !isLoading && (!data || !data.email)) {
    return (
      <div className={classes.UserSearchSuggestion}>
        <div className={classes.noResults}>
          No users found
        </div>
      </div>
    );
  }

  // Show "create user" option when canCreateUser is enabled and email is valid
  if (canCreateUser && validateEmail(lastEmail) && !isLoading && (!data || !data.email)) {
    return (
      <div
        className={classes.UserSearchSuggestion}
        onClick={() => {
          if (onCreateUserRequest) {
            onCreateUserRequest(lastEmail);
          }
          setIsUserSearchSuggestionVisible(false);
        }}
      >
        <div className={classes.emptySuggestion}>
          No users found. Click here to add
        </div>
      </div>
    );
  }

  // Hide suggestions when no data or email already included, but not when loading
  if (!isLoading && (!data || value.includes(data.email))) {
    return null;
  }

  return (
    <div
      className={classes.UserSearchSuggestion}
      onClick={() => {
        setValue((prevData) => {
          const emails = prevData.split(';');

          if (emails.includes(data.email)) {
            return prevData;
          }

          const emailsWithReplace = emails.map((email, index) => {
            if (index === emails.length - 1) {
              return data.email;
            }
            return email.trim();
          });

          return emailsWithReplace.join('; ');
        });

        // Notify parent component that suggestion was selected
        if (onSuggestionSelected) {
          onSuggestionSelected(data.email);
        }

        setIsUserSearchSuggestionVisible(false);
      }}
    >
      <div className={classes.avatarContainer}>
        <img
          src={getUserPhotoUrl(data?.photoPath) || prolfileIcon}
          alt="User"
        />
      </div>
      <div className={classes.details}>
        <h3 className={classes.title}>{data?.name}</h3>
        <span>{data?.email}</span>
      </div>
    </div>
  );
}
